module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/opponent-jorge-masvidal-3.15261ab2.png";